import { hot } from 'react-hot-loader/root'
import React, {useEffect} from 'react'

import {useDispatch} from "react-redux";

import 'mapbox-gl/dist/mapbox-gl.css'
import 'react-map-gl-geocoder/dist/mapbox-gl-geocoder.css'
import './css/index.css'
import './css/tooltip.css'
import 'antd/dist/antd.css'
import './css/custom-theme.css'

import TheEntireMapApp from './TheEntireMapApp'
import StartScreenHOC from './UIComponents/StartScreens/StartScreenHOC'
import FeatureTour from './UIComponents/FeatureTour/FeatureTour'
import {loadTheStoryMap} from "./Redux/Actions/mapActions";


export default hot(
  React.memo(
    () => {
      const dispatch = useDispatch()
      useEffect(() => {
        dispatch(loadTheStoryMap())
      }, [])
      
      return (
        <div className="map-wrapper">
          <StartScreenHOC />
          <TheEntireMapApp />
          <FeatureTour />
        </div>
      )
    }
  )
)


